<div role="main" class="main">
  <div class="slider-container rev_slider_wrapper" style="height:400px;">


     <div id="revolutionSlider" class="slider rev_slider" data-plugin-revolution-slider data-plugin-options='{"delay": 9000, "gridwidth": 800, "gridheight": 270}'>
        <ul>
           <li data-transition="fade" >
              <img src="assets/img/slides/landing-page-slide-1.jpg"
                alt=""
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                class="rev-slidebg">

              <div class="tp-caption main-label"
                data-x="center" data-hoffset="0"
                data-y="center" data-voffset="-95"
                data-start="1500"
                data-whitespace="nowrap"
                data-transform_in="y:[100%];s:500;"
                data-transform_out="opacity:0;s:500;"
                style="z-index: 5; font-size: 20pt !important;padding-top: 3em;"
                data-mask_in="x:0px;y:0px;">MOBİL / WEB UYGULAMASINA İHTİYACINIZ MI VAR?</div>

              <div class="tp-caption"
                data-x="center" data-hoffset="-315"
                data-y="center" data-voffset="-45"
                data-start="1000"
                style="z-index: 5;padding-top: 5em;"
                data-transform_in="x:[-300%];opacity:0;s:600;"><img src="assets/img/slides/slide-title-border.png" alt=""></div>

              <div class="tp-caption top-label"
                data-x="center" data-hoffset="0"
                data-y="center" data-voffset="-45"
                data-start="500"
                style="z-index: 5;padding-top: 3em;"
                data-transform_in="y:[-300%];opacity:0;s:600;">Intes Technology yenilikçi ve yaratıcı fikirler sunuyor.</div>

              <div class="tp-caption"
                data-x="center" data-hoffset="315"
                data-y="center" data-voffset="-45"
                data-start="1000"
                style="z-index: 5;padding-top: 5em;"
                data-transform_in="x:[300%];opacity:0;s:600;"><img src="assets/img/slides/slide-title-border.png" alt=""></div>



           <!--<li data-transition="fade">
              <img src="assets/video/landing.jpg"
                 alt=""
                 data-bgposition="center center"
                 data-bgfit="cover"
                 data-bgrepeat="no-repeat"
                 class="rev-slidebg">
              <div class="rs-background-video-layer"
                 data-forcerewind="on"
                 data-volume="mute"
                 data-videowidth="100%"
                 data-videoheight="100%"
                 data-videomp4="video/landing.mp4"
                 data-videopreload="preload"
                 data-videoloop="none"
                 data-forceCover="1"
                 data-aspectratio="16:9"
                 data-autoplay="true"
                 data-autoplayonlyfirsttime="false"
                 data-nextslideatend="true"
                 ></div>
              <div class="tp-caption"
                 data-x="center" data-hoffset="-180"
                 data-y="center" data-voffset="-95"
                 data-start="1000"
                 style="z-index: 5"
                 data-transform_in="x:[-300%];opacity:0;s:500;"><img src="assets/img/slides/slide-title-border.png" alt=""></div>
              <div class="tp-caption top-label"
                 data-x="center" data-hoffset="0"
                 data-y="center" data-voffset="-95"
                 data-start="500"
                 style="z-index: 5"
                 data-transform_in="y:[-300%];opacity:0;s:500;">SANAL GERÇEKLİK DÜNYASI</div>
              <div class="tp-caption"
                 data-x="center" data-hoffset="180"
                 data-y="center" data-voffset="-95"
                 data-start="1000"
                 style="z-index: 5"
                 data-transform_in="x:[300%];opacity:0;s:500;"><img src="assets/img/slides/slide-title-border.png" alt=""></div>
              <div class="tp-caption main-label"
                 data-x="center" data-hoffset="0"
                 data-y="center" data-voffset="-45"
                 data-start="1500"
                 data-whitespace="nowrap"
                 data-transform_in="y:[100%];s:500;"
                 data-transform_out="opacity:0;s:500;"
                 style="z-index: 5; font-size: 30pt !important;"
                 data-mask_in="x:0px;y:0px;">PROJELERİNİZİ SANAL DÜNYAYA TAŞIYALIM MI?</div>
              <div class="tp-caption bottom-label"
                 data-x="center" data-hoffset="0"
                 data-y="center" data-voffset="5"
                 data-start="2000"
                 style="z-index: 5"
                 data-transform_in="y:[100%];opacity:0;s:500;">71M+ Mutlu Müşteri Arasına Katılın</div>
              <a class="tp-caption btn btn-lg btn-primary btn-slider-action"
                 data-hash
                 data-hash-offset="85"
                 href="assets/#home-intro"
                 data-x="center" data-hoffset="0"
                 data-y="center" data-voffset="80"
                 data-start="2200"
                 data-whitespace="nowrap"
                 data-transform_in="y:[100%];s:500;"
                 data-transform_out="opacity:0;s:500;"
                 style="z-index: 5"
                 data-mask_in="x:0px;y:0px;">Şimdi Başla!</a>
              <div class="tp-dottedoverlay tp-opacity-overlay"></div>
           </li>-->
        </ul>
     </div>
  </div>
  <div class="home-intro" id="home-intro">
     <div class="container">
     </div>
  </div>
  <div class="container">
     <div class="row">
        <div class="col-md-12 center">
           <h2 class="mb-sm word-rotator-title">
      Intes Technology olarak sadece iyi
      <strong class="inverted">
        <span class="word-rotate" data-plugin-options='{"delay": 2000, "animDelay": 300}'>
          <span class="word-rotate-items">
            <span>projeye</span>
            <span>arayüze</span>
            <span>koda</span>
          </span>
        </span>
      </strong>
      değil bunların mükemmel dengesine inanıyoruz.
    </h2>
           <p class="lead">Sizler için oluşturacağımız uygulamalar ile müşterilerinizin sizi tercih etmesinde önemli avantaj sağlayabilirsiniz. Intes Technology olarak, standart kalıpların dışına çıkarak, geleceğin teknolojilerini kullanan mobil uygulamaları ve web siteleri geliştiriyoruz.
           <!--<br><br><br>2018 yılı beklentileri-->
           </p>
        </div>
     </div>





     <!--<div class="row mt-xl">
        <div class="counters counters-text-dark">
           <div class="col-md-3 col-sm-6">
              <div class="counter appear-animation" data-appear-animation="fadeInUp" data-appear-animation-delay="300">
                 <i class="fa fa-user"></i>
                 <strong data-to="71" data-append="M+">0</strong>
                 <label>Mutlu Kullanıcı</label>
                 <p class="text-color-primary mb-xl">Yanılmış olamazlar</p>
              </div>
           </div>
           <div class="col-md-3 col-sm-6">
              <div class="counter appear-animation" data-appear-animation="fadeInUp" data-appear-animation-delay="600">
                 <i class="fa fa-usd"></i>
                 <strong data-to="5200" data-append="M">0</strong>
                 <label>Kazanç Miktarı</label>
                 <p class="text-color-primary mb-xl">Getirisi oldukça fazla</p>
              </div>
           </div>
           <div class="col-md-3 col-sm-6">
              <div class="counter appear-animation" data-appear-animation="fadeInUp" data-appear-animation-delay="900">
                 <i class="fa fa-shopping-cart"></i>
                 <strong data-to="38.8" data-append="M+">0</strong>
                 <label>Gözlük Satışı</label>
                 <p class="text-color-primary mb-xl">Memnuniyet garantili</p>
              </div>
           </div>
           <div class="col-md-3 col-sm-6">
              <div class="counter appear-animation" data-appear-animation="fadeInUp" data-appear-animation-delay="1200">
                 <i class="fa fa-percent"></i>
                 <strong data-to="13000">0</strong>
                 <label>Büyüme Yüzdesi</label>
                 <p class="text-color-primary mb-xl">iPhone'a göre 5 kat daha hızlı</p>
              </div>
           </div>
        </div>
     </div>-->
  </div>

  <section class="section section-default section-with-mockup mb-none">
     <div class="container">
        <div class="row">
           <div class="col-md-4">
              <div class="feature-box feature-box-style-2 reverse mb-xl appear-animation" data-appear-animation="fadeInLeft" data-appear-animation-delay="300">
                 <div class="feature-box-icon">
                    <i class="fa fa-modx"></i>
                 </div>
                 <div class="feature-box-info">
                    <h4 class="mb-sm" style="font-size: 20px  !important;"><b>Yenilikçi Teknoloji</b></h4>
                    <p class="mb-lg" style="font-size: 16px !important;">Gerçekleştirmek istenilen fikrin, mobil/web ortamlarında en iyi şekilde hayata geçmesi için hızlı, yeni teknolojilerle, şık bir tasarımla (UI), en iyi kullanıcı deneyimi (UX) ile ve dinamik Intes Technology ekibimizle sağlıyoruz.</p>
                 </div>
              </div>
              <div class="feature-box feature-box-style-2 reverse mt-xl appear-animation" data-appear-animation="fadeInLeft" data-appear-animation-delay="600">
                 <div class="feature-box-icon">
                    <i class="fa fa-cogs"></i>
                 </div>
                 <div class="feature-box-info">
                    <h4 class="mb-sm" style="font-size: 20px  !important;"><b>Proje Geliştirme</b></h4>
                    <p class="mb-lg" style="font-size: 16px !important;">Mobil ve web dünyasında, yenilikçi ve kaliteli projelerde yer alan ekibimiz ile; fikir aşamasından ele alarak, geçerli proje geliştirme süreçlerinin tüm adımlarını gerçekleştirerek, projeleri ön gürülen süre ve maliyetlerde hayata geçiriyoruz.</p>
                 </div>
              </div>
           </div>
           <div class="col-md-4" style="margin-top: 90px  !important;">
              <img src="assets/img/mockup-porto.png" class="img-responsive mockup-landing-page mb-xl appear-animation" alt="Porto" data-appear-animation="fadeInDown" data-appear-animation-delay="300">
           </div>
           <div class="col-md-4">
              <div class="feature-box feature-box-style-2 mb-xl appear-animation" data-appear-animation="fadeInRight" data-appear-animation-delay="300">
                 <div class="feature-box-icon">
                    <i class="fa fa-shield"></i>
                 </div>
                 <div class="feature-box-info">
                    <h4 class="mb-sm" style="font-size: 20px  !important;"><b>Kalite</b></h4>
                    <p class="mb-lg" style="font-size: 16px !important;">Sizin için geliştireceğimiz ürünler için en iyisini yapmaya hazırız. Ürün kalitesini, en gerçekçi renderlarla, en az hata ile, yüksek performans, kod kalitesi yüksek parametreleri ile sağlıyoruz. &thinsp;&thinsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</p>
                 </div>
              </div>
              <div class="feature-box feature-box-style-2 mt-xl appear-animation" data-appear-animation="fadeInRight" data-appear-animation-delay="600">
                 <div class="feature-box-icon">
                    <i class="fa fa-users"></i>
                 </div>
                 <div class="feature-box-info">
                    <h4 class="mb-sm" style="font-size: 20px  !important;"><b>Danışmanlık/Eğitim</b></h4>
                    <p class="mb-lg" style="font-size: 16px !important;">Kendi alanlarında uzman ve en iyisini elde etmiş deneyimli Intes Technology ekibi ile ihtiyaç duyduğunuz zaman projenize ve size destek sağlıyoruz. İş başı eğitimlerimizle projelerinizin temellerini birlikte atıyoruz.</p>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </section>
  <div class="home-intro" id="home-intro">
     <div class="container">
     </div>
  </div>
  <div class="container">
     <div class="row center">
        <div class="col-md-12">
           <h1 class="mb-sm word-rotator-title">
              Intes Technology olarak
              <strong class="inverted">
              <span class="word-rotate" data-plugin-options='{"delay": 2000, "animDelay": 300}'>
              <span class="word-rotate-items">
              <span>IOS</span>
              <span>Android</span>
              <span>Web</span>
              </span>
              </span>
              </strong>
              platformlarına uyumlu uygulamalar geliştiriyoruz.
           </h1>
           <p class="lead">
              En modern güvenlik ve yazılım teknolojilerini kullanarak üstün performanslı uygulamalar yapmaktayız.
           </p>
        </div>
     </div>
  </div>
  <div class="home-concept">
     <div class="container">
        <div class="row center">
           <span class="sun"></span>
           <span class="cloud"></span>
           <div class="col-md-2 col-md-offset-1">
              <div class="process-image appear-animation" data-appear-animation="bounceIn" data-appear-animation-delay="200">
                 <img src="assets/img/home-concept-item-2.png" alt="" />
                 <strong>Planlama</strong>
              </div>

           </div>
           <div class="col-md-2">
              <div class="process-image appear-animation" data-appear-animation="bounceIn" data-appear-animation-delay="400">
                 <img src="assets/img/home-concept-item-3.png" alt="" />
                 <strong>Geliştirme</strong>
              </div>
           </div>
           <div class="col-md-3">
              <div class="process-image appear-animation" data-appear-animation="bounceIn">
                 <img src="assets/img/home-concept-item-1.png" alt="" />
                 <strong>Eğitim</strong>
              </div>
           </div>
           <div class="col-md-3">
            <div class="project-image process-image appear-animation" data-appear-animation="bounceIn">
               <img style="width: 96%;margin: 8px 8px;border-radius: 180px;height: auto;max-width: none;max-height: none;" src="assets/img/projects/project-home-1.jpg" alt="" />
               <strong class="our-work">işimiz</strong>
            </div>
         </div>

        </div>
     </div>
  </div>
  <div class="home-intro" id="home-intro">
     <div class="container">
     </div>
  </div>
  <div class="container">
     <div class="row">
        <div class="col-md-12 center">
           <h2 class="mt-xl mb-none">Temel <strong>Özelliklerimiz</strong></h2>
           <p class="lead mb-xl">Intes Technology'i seçmek için pek çok neden vardır.</p>
           <hr class="invisible">
        </div>
     </div>
     <div class="row mb-xl">
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Tecrübe</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Akıllı ve Hızlı Çözüm</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Kalite</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Modern</strong></h4>
              </div>
           </div>
        </div>
     </div>
     <div class="row mb-xl">
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Kullanıcı Dostu</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Yaratıcı</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Güvenilir</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Şeffaf</strong></h4>
              </div>
           </div>
        </div>
     </div>
     <div class="row mb-xl">
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Farklı</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Kaliteli Kaynaklar</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Hızlı Destek</strong></h4>
              </div>
           </div>
        </div>
        <div class="col-md-3">
           <div class="feature-box feature-box-style-6">
              <div class="feature-box-icon">
                 <i class="fa fa-check text-color-primary"></i>
              </div>
              <div class="feature-box-info">
                 <h4 class="pt-xs"><strong class="semi-bold">Kullanıcı Rehberi</strong></h4>
              </div>
           </div>
        </div>
     </div>
     <div class="row">
        <div class="col-md-12 center">
           <hr>
           <h2><span class="alternative-font font-size-md mt-xl">ve daha fazlası...</span></h2>
        </div>
     </div>
  </div>
</div>
